import React, { useEffect, useState } from "react";
import Style from "../style/claim.module.scss";

type ContentData = {
  id: number;
  image: string;
  title: string;
  paragraph: string;
  text: string;
  button: string;
};

const Claim = () => {
  const [content, setContent] = useState<ContentData | null>(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await fetch("http://localhost:8000/api/content");
        const data = await res.json();
        setContent(data[0]); // 👈 Get the first item
      } catch (err) {
        console.error("Error fetching content:", err);
      }
    };

    fetchContent();
  }, []);

  if (!content) return null;

  return (
    <div className={Style.container}>
      <div className={Style.wrapper}>
        <div className={Style.content}>
          <div className={Style.Image}>
            <img src={content.image} alt="Guide" loading="lazy" />
          </div>
          <div className={Style.mainbox}>
            <div className={Style.text}>
              <h2 dangerouslySetInnerHTML={{ __html: content.title }}></h2>
              <p>{content.paragraph}</p>
              <h3 dangerouslySetInnerHTML={{ __html: content.text }}></h3>
              <a href="#/">{content.button}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Claim;
